<template>
    <div>
        <label for="">{{ name }}</label>
        <select class="form-control" v-model="selected" @change="$emit('select-option', name, selected)">
            <option v-for="option in options" :value="option.value">{{ option.value }}</option>
        </select>
    </div>
</template>

<script>
    export default {
        props: ['name', 'options'],
        data() {
            return {
                selected: null,
            }
        }
    }
</script>